import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-accessibility-toolbar',
  imports: [CommonModule],
  templateUrl: './accessibility-toolbar.html',
  styleUrl: './accessibility-toolbar.css',
})
export class AccessibilityToolbar implements OnInit {
  private readonly minScale = 0.9;
  private readonly maxScale = 1.2;
  private readonly step = 0.05;
  private readonly scaleKey = 'ui_font_scale';
  private readonly contrastKey = 'ui_high_contrast';

  fontScale = 1;
  highContrast = false;

  ngOnInit(): void {
    const storedScale = Number(localStorage.getItem(this.scaleKey));
    this.fontScale = Number.isFinite(storedScale) && storedScale > 0 ? storedScale : 1;
    this.highContrast = localStorage.getItem(this.contrastKey) === '1';
    this.applySettings();
  }

  decreaseFont(): void {
    this.fontScale = Math.max(this.minScale, Number((this.fontScale - this.step).toFixed(2)));
    this.persistAndApply();
  }

  increaseFont(): void {
    this.fontScale = Math.min(this.maxScale, Number((this.fontScale + this.step).toFixed(2)));
    this.persistAndApply();
  }

  toggleContrast(): void {
    this.highContrast = !this.highContrast;
    this.persistAndApply();
  }

  private persistAndApply(): void {
    localStorage.setItem(this.scaleKey, String(this.fontScale));
    localStorage.setItem(this.contrastKey, this.highContrast ? '1' : '0');
    this.applySettings();
  }

  private applySettings(): void {
    document.documentElement.style.setProperty('--app-font-scale', String(this.fontScale));
    document.body.classList.toggle('high-contrast', this.highContrast);
  }
}
